<template>
  <div class="w-full h-32 sm:h-40 md:h-48 lg:h-96 rounded-lg shadow-md bg-map-matane mx-auto mt-6 md:mt-10">

  </div>

</template>

<script setup>


</script>